'use client';

import React from 'react';
import styles from './FormHeader.module.scss';

interface IFormHeader {
    label: string;
}

export const FormHeader: React.FC<IFormHeader> = ({ label }) => <div className={styles.label}>{label}</div>;
